<div class="processes-list-container">
    <app-spinner
            [isEnable]="isSpinnerEnable"
            loaderClass="create-process-spinner"></app-spinner>
    <div class="row">
        <div class="head-component m-b-25">
            <div class="row col-10 p-l-20 br-0 m-0 head-component for-fixed-component card">
                <div class="col-9 pl-0 p-r-25 card-body">
                    <div class="float-left">
                        <h5 class="m-0 head-main-component">
                            Processes
                        </h5>
                        <div class="process-filter">
                            <span (click)="onStageChanged(null)"
                                  [class.filter-active]="processFilter.stage == null">All</span>
                            <span (click)="onStageChanged(processStage.Active)"
                                  [class.filter-active]="processFilter.stage === processStage.Active">Active</span>
                            <span (click)="onStageChanged(processStage.Completed)"
                                  [class.filter-active]="processFilter.stage === processStage.Completed">Completed</span>
                            <span (click)="onStageChanged(processStage.Draft)"
                                  [class.filter-active]="processFilter.stage === processStage.Draft">Drafts</span>
                            <span (click)="onStageChanged(processStage.Cancelled)"
                                  [class.filter-active]="processFilter.stage === processStage.Cancelled">Cancelled</span>
                            <span (click)="onStageChanged(processStage.Pending)"
                                  [class.filter-active]="processFilter.stage === processStage.Pending">Pending</span>
                        </div>
                    </div>
                    <app-process-list-action-menu *ngIf="processes" (onChangesMade)="getByFilters()"
                                                  [processes]="processes"></app-process-list-action-menu>
                </div>
                <div class="col-3 pr-4 d-flex justify-content-end">
                        <div [routerLink]="['/admin/process-builder']" class="pr-4 m-b-5 m-t-30 d-flex">
                            Create new process
                            <div class="create-new-process"></div>
                        </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row p-l-25">
                <div *ngIf="selectorProcesses.length" [class.process-header]="isSelectedProcesses" class="d-flex justify-content-between row">
                        <div class="col-9 checked-pocesses d-flex">
                            <div *ngIf="getSelectedProcesses().length">
                                <span>{{ getSelectedProcesses().length }}</span>
                                {{ getSelectedProcesses().length > 1 ? 'items selected' : 'item selected' }}
                                <button (click)="clearAll()" ><i class="ti-close"></i></button>
                            </div>
                        </div>
                        <div class="row col-3 p-0 justify-content-end">
                            <button *ngIf="getIsImportBtnEnabled()" (click)="fileInput.click()" class="btn-import-file">Import</button>
                            <input type="file" id="file" (change)="onFileAdded($event)" #fileInput required />
                            <button *ngIf="getIsExportBtnEnabled()" (click)="exportSelectedProcess()" class="btn-import-file">Export</button>
                        </div>
                </div>
        <div class="col-9 pl-0 pr-0 processes-list">
            <div *ngFor="let process of selectorProcesses | filter : ['name'] : searchInput.value; let i = index;" class="d-flex align-items-center">
                <div>
                    <input type="checkbox" [id]="i" [checked]="process.isSelected" (click)="toggleProcess(process)">
                    <label [for]="i"> </label>
                </div>
                <app-process [process]="process" (click)="navigateToProcess(process)" class="width"></app-process>
            </div>
        </div>
        <div class="col-3 p-t-20 pl-0 pr-0">
            <div class="card bg-none pl-0 position-relative fixed-search-block">
                <div class="card-body p-l-25 fixed-right">
                    <div class="col-12 p-0">
                        <div class="mb-1" id="process_filter_name">
                            Process name
                        </div>
                        <div>
                            <input class="w-100" id="process_filter_input" type="text" name="name" #searchInput
                                   (keyup)="searchInput.value"/>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="survey_filter_name">
                            Survey name
                        </div>
                        <div>
                            <input class="w-100" id="survey_filter_input" [(ngModel)]="processFilter.surveyName"
                                   (ngModelChange)="onFilterChanged()" type="text" name="name"/>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="date_filter_name">
                            Start date
                        </div>
                        <div>
                            <input class="w-50 pl-1 pr-4" id="process_date_input_field" type="text"
                                   #startDate="bsDatepicker" [(ngModel)]="processFilter.startDate"
                                   (ngModelChange)="onFilterChanged()" bsDatepicker/>
                            <i (click)="startDate.toggle()" class="fa fa-calendar"></i>
                            <i *ngIf="processFilter.startDate" (click)="onDatepickerCleared()"
                               class="datepicker-clear mdi mdi-close"></i>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="appraise_filter_name">
                            Appraisee
                        </div>
                        <div>
                            <ngx-select [allowClear]="true"
                                        [disabled]="false"
                                        [items]="employees"
                                        [ngModel]="processFilter.employeeId"
                                        optionValueField="id"
                                        optionTextField="name"
                                        (remove)="onEmployeeFilterSelected(0)"
                                        (select)="onEmployeeFilterSelected($event)"
                                        (typed)="onEmployeeFilterTyped($event)">
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="appraise_filter_name">
                            Respondent
                        </div>
                        <div>
                            <ngx-select [allowClear]="true"
                                        [disabled]="false"
                                        [items]="respondents"
                                        [ngModel]="processFilter.respondentId"
                                        optionValueField="id"
                                        optionTextField="name"
                                        (remove)="onRespondentFilterSelected(0)"
                                        (select)="onRespondentFilterSelected($event)"
                                        (typed)="onRespondentFilterTyped($event)">
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="bu_filter_name">
                            Business Unit
                        </div>
                        <div class="limit-styles">
                            <ngx-select [allowClear]="true"
                                        [disabled]="false"
                                        [items]="businessUnits"
                                        [ngModel]="processFilter.businessUnitId"
                                        optionValueField="id"
                                        optionTextField="displayName"
                                        (remove)="onBusinessUnitFilterSelected(0)"
                                        (select)="onBusinessUnitFilterSelected($event)"
                                        (typed)="onBusinessUnitFilterTyped($event)">
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="grade_filter_name">
                            Grade appraise
                        </div>
                        <div class="limit-styles">
                            <ngx-select [allowClear]="true"
                                        [disabled]="false"
                                        [items]="grades"
                                        [ngModel]="processFilter.gradeId"
                                        optionValueField="id"
                                        optionTextField="name"
                                        (remove)="onGradeFilterSelected(0)"
                                        (select)="onGradeFilterSelected($event)">
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-12 mt-2 p-0">
                        <div class="mb-1" id="process_type_block_name">
                            Type
                        </div>
                        <div class="type-process">
                            <span>
                                <input type="checkbox" id="checkbox0"
                                       [checked]="processFilter?.processTypes?.includes(knownProcessType.PME)"
                                       (change)="toggleProcessTypeFilter(knownProcessType.PME)">
                                <label for="checkbox0">{{ knownProcessType.PMEDescription }}</label>
                            </span>
                            <span>
                                <input type="checkbox" id="checkbox1"
                                       [checked]="processFilter?.processTypes?.includes(knownProcessType.PMQ)"
                                       (change)="toggleProcessTypeFilter(knownProcessType.PMQ)">
                                <label for="checkbox1">{{ knownProcessType.PMQDescription }}</label>
                            </span>
                            <span>
                                <input type="checkbox" id="checkbox2"
                                       [checked]="processFilter?.processTypes?.includes(knownProcessType._360)"
                                       (change)="toggleProcessTypeFilter(knownProcessType._360)">
                                <label for="checkbox2">{{ knownProcessType._360Description }}</label>
                            </span>
                            <span>
                                <input type="checkbox" id="checkbox3"
                                       [checked]="processFilter?.processTypes?.includes(knownProcessType.Combined)"
                                       (change)="toggleProcessTypeFilter(knownProcessType.Combined)">
                                <label for="checkbox3">{{ knownProcessType.CombinedDescription }}</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
